import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {PartnerService} from '../../../shared/services/partner.service';
import {UniversityService} from '../../../shared/services/university.service';
import {AlertService} from '../../../shared/services/alert.service';

@Component({
    selector: 'app-partner-linked-universities',
    templateUrl: './partner-linked-universities.component.html',
    styleUrls: ['./partner-linked-universities.component.scss']
})
export class PartnerLinkedUniversitiesComponent implements OnInit {
    partnerSlug: any;
    partnerId: any;
    showLinkPanel = false;
    searchForm: FormGroup;
    searching: any = false;
    submitting: any = false;
    allUniversities = [];
    searchResults = [];
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };
    universities = [];

    constructor(private activatedRoute: ActivatedRoute,
                private router: Router,
                private fb: FormBuilder,
                private partnerService: PartnerService,
                private universityService: UniversityService,
                private alertService: AlertService) {
    }

    ngOnInit(): void {
        this.searchForm = this.fb.group({
            'name': ['']
        });
        this.partnerSlug = this.activatedRoute.snapshot.parent.params['slug'];
        this.partnerService.detail(this.partnerSlug).subscribe(data => {
            if (data && data['id']) {
                this.partnerId = data['id'];
                this.get();
            }
        });
    }

    toggleLinkPanel(): void {
        this.showLinkPanel = !this.showLinkPanel;
        this.searchResults = [];
        this.searchForm.patchValue({'name': ''});
        if (this.showLinkPanel && this.allUniversities.length === 0) {
            this.loadAllUniversities();
        }
    }

    loadAllUniversities() {
        this.searching = true;
        this.universityService.get({'page': -1, 'per_page': 500}).subscribe(data => {
            this.allUniversities = (data && data['data']) ? data['data'] : [];
            this.searching = false;
        }, error => {
            this.searching = false;
        });
    }

    get(page: any = 1) {
        this.pagination.page = page;
        this.submitting = true;
        this.universityService.get({
            'partner_id': this.partnerId,
            'page': this.pagination.page,
            'per_page': this.pagination.perpage
        }).subscribe(data => {
            if (data && data['data'] && data['data'].length > 0) {
                this.universities = data['data'];
                this.pagination = {
                    page: data.current_page,
                    total: data.total,
                    perpage: data.per_page,
                    pages: data.last_page,
                };
            } else {
                this.universities = [];
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    onPageChange(page) {
        this.get(page);
    }

    search() {
        const term = ((this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : '').trim().toLowerCase();
        if (!term) {
            this.searchResults = [];
            return;
        }
        this.searchResults = this.allUniversities.filter(university =>
            (university.partner_id !== this.partnerId) &&
            ((university.name && university.name.toLowerCase().indexOf(term) > -1) ||
                (university.short_name && university.short_name.toLowerCase().indexOf(term) > -1))
        ).slice(0, 20);
    }

    link(university) {
        this.submitting = true;
        this.universityService.updatePartner(university.id, {'partner_id': this.partnerId}).subscribe(() => {
            this.submitting = false;
            this.alertService.showSuccess({title: 'Success', message: 'University linked successfully'});
            this.toggleLinkPanel();
            this.get(1);
        }, error => {
            this.submitting = false;
        });
    }

    pcbMappingPage(university) {
        this.router.navigateByUrl('university-pcb-mapping/' + university.id);
    }

    unlink(university) {
        this.submitting = true;
        this.universityService.updatePartner(university.id, {'partner_id': ''}).subscribe(() => {
            this.submitting = false;
            this.get(this.pagination.page);
        }, error => {
            this.submitting = false;
        });
    }
}
